module.exports = __webpack_public_path__ + "static/sl-0ec944e73c2a3021944c87f97bd3e9e5.png";